import { ApiSimpleOnboarding } from "@incendium/api";
import { listOnboading } from "features/onboarding/services/onboardingService";
import { useGlobalSharedState } from "Hooks/useSharedState";

export const useAllOnboarding = () => {
  const fetch = async () => {
    const res = await listOnboading();
    return res;
  };
  const { state, setState, loading } = useGlobalSharedState<ApiSimpleOnboarding[]>(
    "allOnboarding",
    [],
    fetch
  );

  return {
    onboarding: state,
    setOnboarding: setState,
    loading,
  };
};
